import { Injectable } from '@angular/core';
import { Resolve, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { HttpBadRequestResponse, HttpNotFoundResponse, HttpUnauthorizedResponse } from '../_helpers';
import { catchError } from 'rxjs/operators';

export function handleResolverError(error: any, router: Router): Observable<null> {
  if (error instanceof HttpNotFoundResponse) {
    router.navigateByUrl('/404', { replaceUrl: true }).catch(() => undefined);
    return of(null);
  }

  if (error instanceof HttpUnauthorizedResponse) {
    return of(null);
  }

  if (error instanceof HttpBadRequestResponse) {
    return of(null);
  }

  console.error('Resolver error:', error);
  return of(null);
}

@Injectable()
export abstract class ResolveBase implements Resolve<any> {

  constructor(protected http: HttpClient, protected router: Router) { }

  abstract req(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>;

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.req(route, state).pipe(
      catchError((error) => handleResolverError(error, this.router))
    );
  }
}
